import React, {Component} from 'react'
import popup from '../../popup'
import { cancelSubscription } from '../../../../redux/user/helpers'

import './style.css'

class View extends Component {
  constructor(props) {
    super(props)
    this.state = {
      fields: props.args.fields,
      isCancellationSuccess: false,
      isCancellationFailure: false
    }
    this.cancelMySubscription = this.cancelMySubscription.bind(this)
  }

  cancelMySubscription() {
    cancelSubscription().then(()=> {
      this.setState({
        isCancellationSuccess: true
      },()=> popup.hide )
    }, ()=> {
      this.setState({
        isCancellationFailure: true
      },()=> popup.hide )
    })
  }

  render() {
    return (
      <div className="cancel-subscription centered">
        {this.state.isCancellationSuccess && (
          <React.Fragment>
            <div className="header">
              <h1>{this.state.fields.subscriptionCancelled}</h1>
            </div>
            <div className="buttons">
              <div className="button site-background-color" onClick={ _ => { popup.hide() } }>{this.state.fields.manageDevicesPopupClose}</div>
            </div>
          </React.Fragment>
        )}
        {this.state.isCancellationFailure && (
          <React.Fragment>
            <div className="header">
              <h1>{this.state.fields.accountSuspended}</h1>
            </div>
            <div className="buttons">
              <div className="button site-background-color" onClick={ _ => { popup.hide() } }>{this.state.fields.manageDevicesPopupClose}</div>
            </div>
          </React.Fragment>
        )}
        {!this.state.isCancellationSuccess && !this.state.isCancellationFailure && (
          <React.Fragment>
            <div className="header">
              <h1>{this.state.fields.cancelPlanHeaderLabel}</h1>
              <p>{this.state.fields.cancelPlanConfirmationMessage}</p>
            </div>
            <div className="buttons">
              <div className="button outlined" onClick={ _ => { popup.hide() } }>{this.state.fields.cancelNoLabel}</div>
              <div className="button site-background-color" onClick={this.cancelMySubscription}>{this.state.fields.cancelYesLabel}</div>
            </div>
          </React.Fragment>
        )}
      </div>
    )
  }
}

export default View;